"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.crudeReducer = void 0;
var typescript_fsa_reducers_1 = require("typescript-fsa-reducers");
var crude_actions_1 = require("../../store/crude/crude.actions");
var configurationTypes_1 = require("../../shared/types/configurationTypes");
var getDefaultAppConfig_1 = __importDefault(require("../../defaults/getDefaultAppConfig"));
var getDefaultAppTheme_1 = __importDefault(require("../../defaults/getDefaultAppTheme"));
var commonTypes_1 = require("../../shared/types/commonTypes");
var actions_exposed_1 = require("../actions.exposed");
var immer_1 = __importDefault(require("immer"));
var licenseTypes_1 = require("../../shared/types/licenseTypes");
var getDefaultLanguage_1 = __importDefault(require("../../defaults/getDefaultLanguage"));
var INITIAL_STATE = {
    language: window.localStorage.getItem('language') || getDefaultLanguage_1.default(),
    availableLanguages: [
        configurationTypes_1.LanguageType['de-DE'],
        configurationTypes_1.LanguageType['en-US'],
        configurationTypes_1.LanguageType['it-IT'],
        configurationTypes_1.LanguageType['es-ES'],
        configurationTypes_1.LanguageType['fr-FR'],
        configurationTypes_1.LanguageType['pl-PL'],
        configurationTypes_1.LanguageType['pt-PT'],
        configurationTypes_1.LanguageType['ru-RU'],
        configurationTypes_1.LanguageType['tr-TR'],
        configurationTypes_1.LanguageType['sv-SE'],
        configurationTypes_1.LanguageType['uk-UA'],
        configurationTypes_1.LanguageType['ro-RO'],
        configurationTypes_1.LanguageType['no-NO'],
        configurationTypes_1.LanguageType['nl-NL'],
        configurationTypes_1.LanguageType['hr-HR'],
        configurationTypes_1.LanguageType['hu-HU'],
        configurationTypes_1.LanguageType['fi-FI'],
        configurationTypes_1.LanguageType['el-GR'],
        configurationTypes_1.LanguageType['da-DK'],
        configurationTypes_1.LanguageType['cs-CZ'],
    ],
    temporaryJoinData: {},
    screenDesign: commonTypes_1.ScreenDesign.desktop,
    darkMode: false,
    loadFilterData: false,
    crudeLabels: {},
    theme: getDefaultAppTheme_1.default(false, 'grey'),
    appLayout: getDefaultAppConfig_1.default(),
    crudeConfiguration: {
        path: '',
        api: {
            app: '',
            restPath: '',
        },
    },
    tableFilterSettings: {},
    dataDisplayMode: commonTypes_1.DataDisplayMode.list,
    messages: [],
    displayMode: commonTypes_1.DisplayMode.table,
    showDialog: false,
    showCollapse: false,
    crudeLicense: (_a = {},
        _a[licenseTypes_1.License.outgoingReferenceFilters] = {
            available: false,
        },
        _a[licenseTypes_1.License.standardFilter] = {
            available: false,
        },
        _a[licenseTypes_1.License.extendedEditForms] = {
            available: true,
        },
        _a[licenseTypes_1.License.i18n] = {
            available: true,
        },
        _a[licenseTypes_1.License.extendedNavigation] = {
            available: true,
        },
        _a[licenseTypes_1.License.richTextEditor] = {
            available: false,
        },
        _a[licenseTypes_1.License.extendedTable] = {
            available: true,
        },
        _a[licenseTypes_1.License.configurableTable] = {
            available: false,
        },
        _a[licenseTypes_1.License.fileUpload] = {
            available: true,
        },
        _a[licenseTypes_1.License.treeView] = {
            available: true,
        },
        _a[licenseTypes_1.License.tooltips] = {
            available: true,
        },
        _a[licenseTypes_1.License.freeJSON] = {
            available: true,
        },
        _a[licenseTypes_1.License.integratedHTML] = {
            available: true,
        },
        _a[licenseTypes_1.License.imageCropper] = {
            available: true,
        },
        _a[licenseTypes_1.License.responsiveViews] = {
            available: true,
        },
        _a),
};
var triggerCrudeMessages = function (data) {
    window.dispatchEvent(new CustomEvent('CrudeMessages', { detail: data }));
};
var triggerCrudeSchema = function (data) {
    window.dispatchEvent(new CustomEvent('CrudeSchema', { detail: data }));
};
exports.crudeReducer = typescript_fsa_reducers_1.reducerWithInitialState(INITIAL_STATE)
    .case(crude_actions_1.setUser, function (state, user) {
    return (__assign(__assign({}, state), { user: user }));
})
    .case(crude_actions_1.setScreenDesign, function (state, screenDesign) {
    return (__assign(__assign({}, state), { screenDesign: screenDesign }));
})
    .case(crude_actions_1.loadFilterData, function (state, loadFilterData) {
    return (__assign(__assign({}, state), { loadFilterData: loadFilterData }));
})
    .case(crude_actions_1.setCrudeFilter, function (state, crudeFilter) {
    return (__assign(__assign({}, state), { crudeFilter: crudeFilter }));
})
    .case(crude_actions_1.setCrudeLicense, function (state, crudeLicense) {
    return (__assign(__assign({}, state), { crudeLicense: crudeLicense }));
})
    .case(crude_actions_1.setActiveTab, function (state, activeTab) {
    return (__assign(__assign({}, state), { activeTab: activeTab }));
})
    .case(crude_actions_1.setActiveEntity, function (state, activeEntity) {
    return (__assign(__assign({}, state), { activeEntity: activeEntity }));
})
    .case(crude_actions_1.setLastActiveEntity, function (state, lastActiveEntity) {
    return (__assign(__assign({}, state), { lastActiveEntity: lastActiveEntity }));
})
    .case(crude_actions_1.setLanguage, function (state, language) {
    return (__assign(__assign({}, state), { language: language }));
})
    .case(crude_actions_1.setTheme, function (state, theme) {
    return (__assign(__assign({}, state), { theme: theme }));
})
    .case(crude_actions_1.setCrudeSchema, function (state, crudeSchema) {
    triggerCrudeSchema(crudeSchema);
    return (__assign(__assign({}, state), { crudeSchema: crudeSchema }));
})
    .case(crude_actions_1.setCrudeLabels, function (state, crudeLabels) {
    return (__assign(__assign({}, state), { crudeLabels: crudeLabels }));
})
    .case(crude_actions_1.setCrudeConfiguration, function (state, crudeConfiguration) {
    window.localStorage.setItem('personalCrudeConfiguration', JSON.stringify(crudeConfiguration));
    return (__assign(__assign({}, state), { crudeConfiguration: crudeConfiguration }));
})
    .case(crude_actions_1.setAppLayout, function (state, appLayout) {
    return (__assign(__assign({}, state), { appLayout: appLayout }));
})
    .case(crude_actions_1.setEditLayout, function (state, editLayout) {
    return (__assign(__assign({}, state), { editLayout: editLayout }));
})
    .case(crude_actions_1.setDarkMode, function (state, darkMode) {
    return (__assign(__assign({}, state), { darkMode: darkMode }));
})
    .case(crude_actions_1.setCrudePath, function (state, crudePath) {
    return (__assign(__assign({}, state), { crudePath: crudePath }));
})
    .case(crude_actions_1.setCrudeTabs, function (state, crudeTabs) {
    return (__assign(__assign({}, state), { crudeTabs: crudeTabs }));
})
    .case(crude_actions_1.setTableFilterSettings, function (state, tableFilterSettings) {
    return (__assign(__assign({}, state), { tableFilterSettings: tableFilterSettings }));
})
    .case(crude_actions_1.setDataDisplayMode, function (state, dataDisplayMode) {
    return (__assign(__assign({}, state), { dataDisplayMode: dataDisplayMode }));
})
    .case(crude_actions_1.setShowDialog, function (state, showDialog) {
    return (__assign(__assign({}, state), { showDialog: showDialog }));
})
    .case(crude_actions_1.setShowCollapse, function (state, showCollapse) {
    return (__assign(__assign({}, state), { showCollapse: showCollapse }));
})
    .case(crude_actions_1.setTemporaryJoinData, function (state, temporaryJoinData) {
    return (__assign(__assign({}, state), { temporaryJoinData: temporaryJoinData }));
})
    .case(crude_actions_1.addMessage, function (state, message) {
    var messages = __spreadArrays(state.messages);
    triggerCrudeMessages(message);
    messages.push(message);
    return (__assign(__assign({}, state), { messages: messages }));
})
    .case(crude_actions_1.setReloadListEntity, function (state, entity) {
    return immer_1.default(state, function (draft) {
        draft.reloadListEntity = entity;
    });
})
    /**
     * Handling of exposed actions
     */
    .case(actions_exposed_1.resetTable, function (state) {
    return immer_1.default(state, function (draft) {
        draft.displayMode = commonTypes_1.DisplayMode.table;
    });
})
    .case(actions_exposed_1.changeLanguage, function (state, language) {
    return (__assign(__assign({}, state), { language: language }));
});
